export const getMetrikaClientId = (ymKey: number) => `metrika.${ymKey}`;
